import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_HEADERS, ENDPOINTS } from '../../constants/api';
import { baseQueryWithAuthCheck } from './helper';
import { callFromMiddleware, extractDomain } from '../../utils';
import { MasterDataResponse } from '../../types/api-response';
import { GetMasterDataPayload } from '../../types/api-payload';

const baseQuery = fetchBaseQuery({
    baseUrl: window.location.origin,
    headers: API_HEADERS,
    credentials: "include"
});
const local = window.location.hostname.includes("localhost") ? true : false;
export const masterDataApi = createApi({
    reducerPath: 'masterData',
    baseQuery: baseQueryWithAuthCheck(baseQuery),
    endpoints: (builder) => ({
        masterData: builder.query<MasterDataResponse, GetMasterDataPayload>({
            query: (args) => ({
                url: local ? callFromMiddleware(ENDPOINTS.getMasterData) : `${extractDomain()}${ENDPOINTS.getMasterData}`,
                method: "GET",
                headers: API_HEADERS,
                params: args,
              }),
        }),
        getV4MasterData: builder.query<any, any>({
            query: (args) => ({
                url: `${callFromMiddleware(ENDPOINTS.getV4MasterData)}/${args.channelId}` ,
              method: "GET",
              headers: API_HEADERS,
              params: {domain: args.domain},
            }),
        }),
    }),
})

export const {
    useMasterDataQuery,
    useGetV4MasterDataQuery,
    useLazyGetV4MasterDataQuery
} = masterDataApi

export default masterDataApi;
